import React from 'react';

const MapEmbed = ({ latitude, longitude }) => {
  // Construct the URL with correct latitude and longitude order
  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
  
  // URL to redirect to when the map is clicked (opens in a new tab)
  const redirectUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15`;

  return (
    <div>
      <a href={redirectUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
        // yes, for this you need webview ooh otherwise we can usee other providers like open srteet ? i think you can get 1$/mo :D
        <iframe
          src={mapUrl}
          width="500"
          height="300"
          style={{ border: 0, pointerEvents: 'none' }} // Disable interactions
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        />
      </a>
    </div>
  );
};

export default MapEmbed;